import { render, staticRenderFns } from "./TravelSalePage.vue?vue&type=template&id=e9cf1ef0&scoped=true"
import script from "./TravelSalePage.vue?vue&type=script&lang=js"
export * from "./TravelSalePage.vue?vue&type=script&lang=js"
import style0 from "./TravelSalePage.vue?vue&type=style&index=0&id=e9cf1ef0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9cf1ef0",
  null
  
)

export default component.exports